import isotipoLogo from './isotipo.png.png';
import React, { useState, useEffect, useCallback } from 'react';
import { db, storage } from './firebase';
import { collection, getDocs, doc, writeBatch, updateDoc, setDoc, deleteDoc, addDoc, getDoc, arrayUnion, query, where } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import * as XLSX from 'xlsx';
import { enviarCorreoRecibo } from './emailService'; 
import PropietarioPortal from './PropietarioPortal';
import ReservasEdificio from './ReservasEdificio';
import PortalGlobal from './PortalGlobal'; 

// Importación de subcomponentes del administrador
import AdminPropietarios from './AdminPropietarios';
import AdminAreasSociales from './AdminAreasSociales';
import AdmiEconomico from './AdmiEconomico';
import AdminNotificaciones from './AdminNotificaciones';
import AdminCarga from './AdminCarga';
import AdminRevision from './AdminRevision';
import AdminHistorico from './AdminHistorico';
import DatosPersonal from './DatosPersonal'; 
import emailjs from '@emailjs/browser';

import BotonInstalarPWA from './BotonInstalarPWA';
import './App.css';

function App() {
  const [usuarioLogueado, setUsuarioLogueado] = useState(null);
  const [inputUsuario, setInputUsuario] = useState('');
  const [inputPassword, setInputPassword] = useState('');

  // 🔐 ESTADOS NUEVOS PARA EL PATRÓN DE SEGURIDAD DEL ADMINISTRADOR
  const [pasoAdminLogin, setPasoAdminLogin] = useState('credenciales'); // 'credenciales' o 'patron'
  const [patronDibuja, setPatronDibuja] = useState('');
  const patronSecretoAdmin = "3-6-9-8-7-4-1-2"; // Secuencia secreta en forma de "L"

  const [edificioActual, setEdificioActual] = useState('');
  const [listaEdificios, setListaEdificios] = useState([]);
  const [nuevoEdificioNombre, setNuevoEdificioNombre] = useState('');
  const [mostrandoModalNuevo, setMostrandoModalNuevo] = useState(false);

  // ✏️ ESTADOS PARA EDITAR EL NOMBRE DEL EDIFICIO ACTIVO
  const [editandoNombreEdificio, setEditandoNombreEdificio] = useState(false);
  const [nombreEdificioEditado, setNombreEdificioEditado] = useState('');

  const [propietarios, setPropietarios] = useState([]);
  const [, setCargando] = useState(false);
  
  const [tituloNotificacion, setTituloNotificacion] = useState('');
  const [mensajeNotificacion, setMensajeNotificacion] = useState('');
  const [enviandoNotificacion, setEnviandoNotificacion] = useState(false);
  const [datosNotificaciones, setDatosNotificaciones] = useState([]); 
  
  const [pestanaLateral, setPestanaLateral] = useState('propietarios');
  const [pestanaCargaSub, setPestanaCargaSub] = useState('excel');
  const [pestanaPropietario, setPestanaPropietario] = useState('mantenimiento');

  const [anioSeleccionadoProp, setAnioSeleccionadoProp] = useState('2026');
  const [subiendoVoucherPropId, setSubiendoVoucherPropId] = useState(null);

  const [areasSociales, setAreasSociales] = useState([]);
  const [formArea, setFormArea] = useState({ 
    nombre: '', 
    costo: '', 
    reglas: '', 
    diasList: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'], 
    horasList: ['09:00 - 22:00'],
    bloqueoDiaCompleto: false // 👈 NUEVO 
  });
  const [nuevoDiaInput, setNuevoDiaInput] = useState('');
  const [nuevaHoraInput, setNuevaHoraInput] = useState('');
  const [mostrandoModalArea, setMostrandoModalArea] = useState(false);
  
  const [reservas, setReservas] = useState([]);
  const [formReserva, setFormReserva] = useState({ areaId: '', departamento: '', fecha: '', horario: 'Mañana (09:00 - 14:00)' });

  const [anioInforme, setAnioInforme] = useState('2026');
  const [mesInforme, setMesInforme] = useState('Unitario');
  const [informesEconomicos, setInformesEconomicos] = useState([]);
  const [subiendoVoucher, setSubiendoVoucher] = useState(false);
  const [descripcionGasto, setDescripcionGasto] = useState('');
  const [progresoInforme, setProgresoInforme] = useState(0);

  // 📂 ESTADOS PARA DOCUMENTOS PERMANENTES
  const [documentosPermanentes, setDocumentosPermanentes] = useState([]);
  const [subiendoPermanente, setSubiendoPermanente] = useState(false);

  const [anioEnvio] = useState(new Date().getFullYear().toString());
  const [mesEnvio] = useState('Julio');
  const [anioHistorico, setAnioHistorico] = useState('2026');
  const [busquedaHistorico, setBusquedaHistorico] = useState(''); 
  
  const [anioActivoBusqueda, setAnioActivoBusqueda] = useState('2026');
  const [datosHistoricos, setDatosHistoricos] = useState([]);

  const [mostrandoModalPropietario, setMostrandoModalPropietario] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [formProp, setFormProp] = useState({ departamento: '', nombre: '', celular: '', correo: '' });

  const [procesandoExcel, setProcesandoExcel] = useState(false);
  const [progresoExcel, setProgresoExcel] = useState(0);
  const [procesandoPdf, setProcesandoPdf] = useState(false);
  const [progresoPdf, setProgresoPdf] = useState(0);

  const obtenerEdificios = async () => {
    try {
      const snapshot = await getDocs(collection(db, 'edificios_mmdl'));
      let edificios = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      if (edificios.length === 0) {
        const defaultEdificio = { id: 'trinidad', nombre: 'Trinidad', fechaCreacion: new Date().toLocaleDateString() };
        await setDoc(doc(db, 'edificios_mmdl', 'trinidad'), defaultEdificio);
        edificios = [defaultEdificio];
      }
      setListaEdificios(edificios);
    } catch (error) {
      console.error("Error al obtener edificios:", error);
      setListaEdificios([{ id: 'trinidad', nombre: 'Trinidad' }]);
    }
  };

  useEffect(() => {
    obtenerEdificios();
  }, []);

  const manejarLogin = async (e) => {
    e.preventDefault();
    const user = inputUsuario.trim();
    const pass = inputPassword.trim();

    if (!user || !pass) {
      alert("Por favor ingresa usuario y contraseña.");
      return;
    }

    if (user === 'globalmmdl' && pass === 'mmdlseguibal') {
      setUsuarioLogueado({ tipo: 'global' });
      setInputUsuario('');
      setInputPassword('');
      return;
    }

    if (user === 'MMDLadmi' && pass === 'admi2020mmdl') {
      setPasoAdminLogin('patron');
      return;
    }

    const userLower = user.toLowerCase();

    try {
      const snapshotEdificios = await getDocs(collection(db, 'edificios_mmdl'));
      
      if (userLower.endsWith('reservas')) {
        const idEdificioIngresado = userLower.replace('reservas', '');
        const edificioEncontrado = snapshotEdificios.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .find(e => e.id.toLowerCase() === idEdificioIngresado);

        if (edificioEncontrado) {
          setUsuarioLogueado({
            tipo: 'personal',
            edificioId: edificioEncontrado.id,
            edificioNombre: edificioEncontrado.nombre
          });
          setInputUsuario('');
          setInputPassword('');
          return;
        }
      }

      let edificioEncontrado = null;
      let departamentoEncontrado = null;

      // 🔍 Búsqueda optimizada por el campo 'usuario' para evitar conflictos con letras en departamentos
      for (let docEdif of snapshotEdificios.docs) {
        const edifData = { id: docEdif.id, ...docEdif.data() };
        
        const q = query(collection(db, `propietarios_${edifData.id}`), where('usuario', '==', userLower));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          edificioEncontrado = edifData;
          departamentoEncontrado = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
          break;
        }
      }

      if (edificioEncontrado && departamentoEncontrado) {
        const passwordAlmacenada = departamentoEncontrado.password;
        const passwordValida = passwordAlmacenada 
          ? passwordAlmacenada === pass 
          : pass.toLowerCase() === userLower;

        if (!passwordValida) {
          alert("❌ Contraseña incorrecta para este departamento.");
          return;
        }

        setUsuarioLogueado({
          tipo: 'propietario',
          edificioId: edificioEncontrado.id,
          edificioNombre: edificioEncontrado.nombre,
          departamento: departamentoEncontrado
        });
        setInputUsuario('');
        setInputPassword('');
      } else {
        alert("❌ Acceso denegado: Usuario o departamento no autorizado.");
      }
    } catch (error) {
      console.error("Error en login:", error);
    }
  };

  const edificioIdActivo = edificioActual ? edificioActual.id : (usuarioLogueado?.tipo === 'propietario' || usuarioLogueado?.tipo === 'personal' ? usuarioLogueado.edificioId : '');
  const nombreColeccion = edificioIdActivo ? `propietarios_${edificioIdActivo}` : '';
  const coleccionAreas = edificioIdActivo ? `areas_${edificioIdActivo}` : '';
  const coleccionReservas = edificioIdActivo ? `reservas_${edificioIdActivo}` : '';
  const coleccionInformes = edificioIdActivo ? `informes_${edificioIdActivo}` : '';
  const coleccionHistorico = edificioIdActivo ? `historico_${edificioIdActivo}` : '';
  const coleccionNotificaciones = edificioIdActivo ? `notificaciones_${edificioIdActivo}` : '';

  const tipoUsuario = usuarioLogueado?.tipo;
  const idDpto = usuarioLogueado?.departamento?.id;

   const obtenerRegistros = useCallback(async () => {
    if (!edificioIdActivo) return;
    try {
      setCargando(true);

      // 🔍 Volver a consultar el documento del edificio para refrescar montos y deducciones en tiempo real
      const edifDocRef = doc(db, 'edificios_mmdl', edificioIdActivo);
      const edifSnap = await getDoc(edifDocRef);
      if (edifSnap.exists()) {
        setEdificioActual({ id: edifSnap.id, ...edifSnap.data() });
      }

      const snapProp = await getDocs(collection(db, nombreColeccion));
      let listaProp = snapProp.docs.map(d => ({ id: d.id, ...d.data() }));
      listaProp.sort((a, b) => (parseInt(String(a.departamento).replace(/\D/g, '')) || 0) - (parseInt(String(b.departamento).replace(/\D/g, '')) || 0));
      setPropietarios(listaProp);

      if (tipoUsuario === 'propietario' && idDpto) {
        const dptoActualizado = listaProp.find(p => p.id === idDpto);
        if (dptoActualizado) {
          setUsuarioLogueado(prev => ({ ...prev, departamento: dptoActualizado }));
        }
      }

      const snapAreas = await getDocs(collection(db, coleccionAreas));
      setAreasSociales(snapAreas.docs.map(d => ({ id: d.id, ...d.data() })));

      const snapRes = await getDocs(collection(db, coleccionReservas));
      setReservas(snapRes.docs.map(d => ({ id: d.id, ...d.data() })));

      const snapInf = await getDocs(collection(db, coleccionInformes));
      setInformesEconomicos(snapInf.docs.map(d => ({ id: d.id, ...d.data() })));

      const snapHist = await getDocs(collection(db, coleccionHistorico));
      let listaHist = snapHist.docs.map(d => ({ id: d.id, ...d.data() }));
      listaHist.sort((a, b) => (parseInt(String(a.departamento).replace(/\D/g, '')) || 0) - (parseInt(String(b.departamento).replace(/\D/g, '')) || 0));
      setDatosHistoricos(listaHist);

      const snapNotif = await getDocs(collection(db, coleccionNotificaciones));
      let listaNotif = snapNotif.docs.map(d => ({ id: d.id, ...d.data() }));
      setDatosNotificaciones(listaNotif);

      const snapPerm = await getDocs(collection(db, `documentos_permanentes_${edificioIdActivo}`));
      setDocumentosPermanentes(snapPerm.docs.map(d => ({ id: d.id, ...d.data() })));

    } catch (error) {
      console.error("Error:", error);
    } finally {
      setCargando(false);
    }
  }, [nombreColeccion, coleccionAreas, coleccionReservas, coleccionInformes, coleccionHistorico, coleccionNotificaciones, edificioIdActivo, tipoUsuario, idDpto]);

  useEffect(() => {
    if (edificioIdActivo) {
      obtenerRegistros();
    }
  }, [edificioIdActivo, obtenerRegistros]);

  const agregarNuevoEdificio = async (e) => {
    e.preventDefault();
    if (!nuevoEdificioNombre.trim()) return;
    const idLimpio = nuevoEdificioNombre.trim().toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
    const nombreFormateado = nuevoEdificioNombre.trim();
    await setDoc(doc(db, 'edificios_mmdl', idLimpio), { id: idLimpio, nombre: nombreFormateado, fechaCreacion: new Date().toLocaleDateString('es-PE') });
    setNuevoEdificioNombre('');
    setMostrandoModalNuevo(false);
    await obtenerEdificios();
    alert(`¡Edificio "${nombreFormateado}" agregado con éxito!`);
  };

  const guardarNombreEdificio = async (e) => {
    e.preventDefault();
    if (!nombreEdificioEditado.trim() || !edificioActual) return;
    
    const nuevoNombre = nombreEdificioEditado.trim();
    try {
      await updateDoc(doc(db, 'edificios_mmdl', edificioActual.id), {
        nombre: nuevoNombre
      });

      const nombreColeccionActual = `propietarios_${edificioActual.id}`;
      const snapProp = await getDocs(collection(db, nombreColeccionActual));
      
      if (!snapProp.empty) {
        const batch = writeBatch(db);
        const nuevoPrefijo = nuevoNombre.toLowerCase().replace(/\s+/g, '').replace(/[^a-z0-9]/g, '');
        
        snapProp.docs.forEach((d) => {
          const data = d.data();
          const dpto = data.departamento;
          // Normalización estricta del departamento para el usuario
          const dptoUsuario = String(dpto).toLowerCase().replace(/[^a-z0-9]/g, '');
          const nuevoUsuario = `${nuevoPrefijo}${dptoUsuario}`;
          batch.update(d.ref, { usuario: nuevoUsuario });
        });
        
        await batch.commit();
      }

      setEdificioActual(prev => ({ ...prev, nombre: nuevoNombre }));
      setEditandoNombreEdificio(false);
      await obtenerEdificios();
      await obtenerRegistros();
      alert(`✅ ¡Nombre del edificio actualizado a "${nuevoNombre}" y usuarios sincronizados con éxito!`);
    } catch (error) {
      console.error("Error al actualizar el nombre del edificio y usuarios:", error);
      alert("❌ Ocurrió un error al actualizar el nombre.");
    }
  };

  const eliminarEdificio = async (e, edif) => {
    e.stopPropagation();
    if (window.confirm(`⚠️ ¿Deseas dejar de administrar el edificio "${edif.nombre}"?`)) {
      await deleteDoc(doc(db, 'edificios_mmdl', edif.id));
      await obtenerEdificios();
    }
  };

  const enviarCredencialesPropietario = (prop) => {
    const dptoUsuarioDefault = String(prop.departamento || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const usuarioGenerico = prop.usuario || `${edificioActual.id}${dptoUsuarioDefault}`;
    const mensaje = `Estimado(a) ${prop.nombre}, le damos la bienvenida al portal de MMD&L Edificios SAC (Edificio ${edificioActual.nombre}). Sus datos de acceso son:\n\nUsuario: ${usuarioGenerico}\nContraseña: ${prop.password || usuarioGenerico}`;
    if (prop.correo && prop.correo.includes('@')) {
      alert(`📧 [Correo a: ${prop.correo}]\n\n${mensaje}`);
    } else {
      alert(`📱 [Celular: ${prop.celular || prop.telefono}]\n\n${mensaje}`);
    }
  };

  const enviarRecibosMasivosPorCorreo = async () => {
    if (propietarios.length === 0) {
      alert("⚠️ No hay propietarios en la previsualización.");
      return;
    }

    if (window.confirm(`¿Deseas enviar los recibos por correo electrónico a todos los propietarios registrados en la previsualización?`)) {
      let enviados = 0;
      let sinCorreo = 0;

      for (let prop of propietarios) {
        if (prop.correo && prop.correo.includes('@')) {
          const montoCuota = formatearMonto(prop.cuota || 0);
          const numeroReciboRef = `REC-${edificioActual.id.toUpperCase()}-${prop.departamento}`;
          
          try {
            await enviarCorreoRecibo(
              prop.correo,
              prop.nombre,
              numeroReciboRef,
              prop.mes,
              prop.anio,
              montoCuota,
              prop.fechaEmision,    
              prop.fechaVencimiento  
            );
            enviados++;
          } catch (err) {
            console.error(`Error enviando a ${prop.correo}:`, err);
          }
        } else {
          sinCorreo++;
        }
      }

      alert(`✅ Envío masivo completado.\n- Correos enviados con éxito: ${enviados}\n- Omitidos por falta de correo válido: ${sinCorreo}`);
    }
  };

  const enviarIndividual = async (prop) => {
    if (!prop.correo || !prop.correo.includes('@')) {
      alert("⚠️ Este propietario no tiene un correo electrónico válido registrado.");
      return;
    }

    try {
      const montoCuota = formatearMonto(prop.cuota || 0);
      const numeroReciboRef = `REC-${edificioActual.id.toUpperCase()}-${prop.departamento}`;
      
      await enviarCorreoRecibo(
        prop.correo,
        prop.nombre,
        numeroReciboRef,
        prop.mes || 'Actual',
        prop.anio || new Date().getFullYear().toString(),
        montoCuota,
        prop.fechaEmision || '-',    
        prop.fechaVencimiento || '-'  
      );

      alert(`✅ Recibo enviado con éxito al Dpto. ${prop.departamento} (${prop.correo})`);
    } catch (error) {
      console.error("Error al enviar correo individual:", error);
      alert("❌ Ocurrió un error al intentar enviar el correo.");
    }
  };

  const aprobarYEnviarIndividual = async (prop) => {
    if (!prop.pdfUrl && (!prop.pdfUrls || prop.pdfUrls.length === 0)) {
      alert("⚠️ Este departamento no cuenta con recibos PDF asociados.");
      return;
    }

    try {
      if (prop.correo && prop.correo.includes('@')) {
        await emailjs.send(
          'service_kdfys3f',
          'template_6100g0e',
          {
            to_email: prop.correo,
            to_name: prop.nombre,
            departamento: prop.departamento,
            mes: prop.mes || mesEnvio,
            anio: prop.anio || anioEnvio,
            cuota: formatearMonto(prop.cuota),
            fecha_vencimiento: prop.fechaVencimiento || 'Pronto',
            pdf_url: prop.pdfUrl,
            nombre_edificio: edificioActual?.nombre || 'Edificio MMD&L'
          },
          'pfJqVpoChzMWTp7L9'
        );
      }

      const mesReal = prop.mes || mesEnvio;
      const anioReal = prop.anio || anioEnvio;
      const idHistoricoUnico = `hist_${anioReal}_${mesReal}_dpto_${prop.departamento}`;
      const refHistDoc = doc(db, coleccionHistorico, idHistoricoUnico);

      await setDoc(refHistDoc, {
        anio: anioReal,
        mes: mesReal, 
        departamento: prop.departamento,
        nombre: prop.nombre,
        cuota: prop.cuota || 'S/ 0.00',
        pdfUrl: prop.pdfUrl || '',
        pdfUrls: prop.pdfUrls || [],
        correo: prop.correo || '',
        celular: prop.celular || '',
        fechaEmision: prop.fechaEmision || '',
        fechaVencimiento: prop.fechaVencimiento || '',
        voucherUrl: '',
        estadoPago: 'Pendiente de validación',
        fechaAprobacion: new Date().toLocaleDateString('es-PE')
      }, { merge: true });

      await updateDoc(doc(db, nombreColeccion, prop.id), {
        cuota: '',
        mes: '',
        anio: '',
        fechaEmision: '',
        fechaVencimiento: '',
        pdfUrl: '',
        pdfUrls: [],
        estado: 'Pendiente'
      });

      await obtenerRegistros();
      alert(`✅ ¡Recibo del Dpto. ${prop.departamento} aprobado, enviado, archivado y removido de la previsualización con éxito!`);
    } catch (error) {
      console.error("Error al aprobar y archivar individualmente:", error);
      alert("❌ Hubo un error al procesar la aprobación individual.");
    }
  };

  const limpiarPrevisualizacion = async () => {
    if (window.confirm("⚠️ ¿Estás seguro de vaciar y borrar las cuotas, montos y PDFs de la previsualización actual?")) {
      try {
        const batch = writeBatch(db);
        propietarios.forEach(prop => {
          const refDoc = doc(db, nombreColeccion, prop.id);
          batch.update(refDoc, {
            cuota: '',
            mes: '',
            anio: '',
            fechaEmision: '',
            fechaVencimiento: '',
            pdfUrl: '',      
            pdfUrls: [],      
            estado: 'Pendiente'
          });
        });
        await batch.commit();
        await obtenerRegistros();
        alert("🧹 ¡Previsualización y recibos PDF borrados con éxito!");
      } catch (error) {
        console.error("Error al limpiar previsualización:", error);
        alert("Hubo un error al limpiar.");
      }
    }
  };

  const descargarPlantilla = () => {
    const estructura = [{ Dpto: 101, "Total a Pagar": 188.30, Mes: "Julio", Año: "2026", "Fecha Emisión": "01/07/2026", "Fecha Vencimiento": "15/07/2026" }];
    const hoja = XLSX.utils.json_to_sheet(estructura);
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hoja, "Plantilla");
    XLSX.writeFile(libro, `Plantilla_Mantenimiento_${edificioActual?.nombre || 'Edificio'}.xlsx`);
  };

  const manejarExcel = (e) => {
    const archivo = e.target.files[0];
    if (!archivo) return;
    const lector = new FileReader();
    lector.onload = async (evento) => {
      try {
        setProcesandoExcel(true);
        setProgresoExcel(10);
        const libro = XLSX.read(evento.target.result, { type: 'binary', cellDates: false });
        setProgresoExcel(30);
        const filas = XLSX.utils.sheet_to_json(libro.Sheets[libro.SheetNames[0]], { raw: false });
        setProgresoExcel(50);
        
        const batch = writeBatch(db);
        let contador = 0;
        const totalFilas = filas.length;

        for (let i = 0; i < totalFilas; i++) {
          let fila = filas[i];
          const dpto = fila['Dpto'] || fila['Departamento'] || 'S/N';
          if (dpto !== 'S/N') {
            const dptoLimpio = String(dpto).trim();
            const idDoc = `dpto_${dptoLimpio.replace(/\s+/g, '_')}`;
            
            const mesLeido = String(fila['Mes'] || mesEnvio).trim();
            const anioLeido = String(fila['Año'] || fila['Anio'] || anioEnvio).trim();

            batch.set(doc(db, nombreColeccion, idDoc), {
              departamento: dptoLimpio,
              cuota: `S/ ${parseFloat(String(fila['Total a Pagar'] || 0).replace(/[^0-9.-]+/g, "")) || 0}`,
              mes: mesLeido,
              anio: anioLeido,
              fechaEmision: String(fila['Fecha Emisión'] || '-').trim(),
              fechaVencimiento: String(fila['Fecha Vencimiento'] || '-').trim(),
              estado: "Pendiente"
            }, { merge: true });
            contador++;
          }
          const porc = Math.round(50 + ((i + 1) / totalFilas) * 40);
          setProgresoExcel(porc);
        }

        await batch.commit();
        setProgresoExcel(100);
        await obtenerRegistros();
        setTimeout(() => {
          setProcesandoExcel(false);
          setProgresoExcel(0);
        }, 600);
        alert(`¡Se procesaron ${contador} montos financieros y fechas con éxito!`);
      } catch (error) {
        console.error(error);
        setProcesandoExcel(false);
        setProgresoExcel(0);
      }
    };
    lector.readAsBinaryString(archivo);
    e.target.value = null;
  };

  const subirPdfsEnBloque = async (e) => {
    const archivos = Array.from(e.target.files);
    if (archivos.length === 0) return;
    try {
      setProcesandoPdf(true);
      setProgresoPdf(10);
      let actualizados = 0;
      const totalArchivos = archivos.length;

      for (let i = 0; i < totalArchivos; i++) {
        const nombreSinExt = archivos[i].name.replace(/\.[^/.]+$/, "");
        
        // Identificar número o código de departamento con letras (ej. 101, 101A, 202-B)
        const matchDpto = nombreSinExt.match(/[0-9]+[A-Za-z]*/);
        if (!matchDpto) {
          console.warn(`No se pudo identificar el departamento en el archivo: ${archivos[i].name}`);
          continue;
        }

        const dptoBase = matchDpto[0]; 
        const docId = `dpto_${dptoBase}`;

        const storageRef = ref(storage, `recibos_${edificioIdActivo}/recibo_${nombreSinExt}_${Date.now()}.pdf`);
        await uploadBytes(storageRef, archivos[i]);
        const urlDescarga = await getDownloadURL(storageRef);
        
        await setDoc(doc(db, nombreColeccion, docId), {
          departamento: dptoBase,
          pdfUrl: urlDescarga, 
          pdfUrls: arrayUnion({
            nombreArchivo: archivos[i].name,
            url: urlDescarga,
            subidoEn: new Date().toLocaleDateString('es-PE')
          })
        }, { merge: true });

        actualizados++;

        const porc = Math.round(((i + 1) / totalArchivos) * 90);
        setProgresoPdf(porc);
      }

      setProgresoPdf(100);
      await obtenerRegistros();
      setTimeout(() => {
        setProcesandoPdf(false);
        setProgresoPdf(0);
      }, 600);
      
      alert(`¡Se asociaron ${actualizados} recibos PDF correctamente en bloque!`);
    } catch (error) {
      console.error("Error al subir los PDFs en bloque:", error);
      setProcesandoPdf(false);
      setProgresoPdf(0);
    }
    e.target.value = null;
  };

  const subirVoucherPropietario = async (e, itemHistoricoId) => {
    const archivo = e.target.files[0];
    if (!archivo) return;
    try {
      setSubiendoVoucherPropId(itemHistoricoId);
      const storageRef = ref(storage, `vouchers_${edificioIdActivo}/voucher_dpto_${usuarioLogueado.departamento.departamento}_${Date.now()}_${archivo.name}`);
      await uploadBytes(storageRef, archivo);
      const urlDescarga = await getDownloadURL(storageRef);
       
      await updateDoc(doc(db, coleccionHistorico, itemHistoricoId), {
        voucherUrl: urlDescarga,
        estadoPago: "En revisión por administración"
      });

      await obtenerRegistros();
      alert("¡Voucher subido con éxito! La administración lo revisará a la brevedad.");
    } catch (error) {
      console.error("Error al subir voucher:", error);
      alert("No se pudo subir el archivo.");
    } finally {
      setSubiendoVoucherPropId(null);
      e.target.value = null;
    }
  };

  const subirVoucherInforme = async (e) => {
    const archivos = Array.from(e.target.files);
    if (archivos.length === 0) return;

    setSubiendoVoucher(true);
    setProgresoInforme(0);

    try {
      let totalArchivos = archivos.length;
      let subidos = 0;

      for (let i = 0; i < totalArchivos; i++) {
        const archivo = archivos[i];
        const nombreOriginal = archivo.name;

        const storageRef = ref(storage, `informes_${edificioIdActivo}/${anioInforme}_${mesInforme}_${Date.now()}_${nombreOriginal}`);
        
        await uploadBytes(storageRef, archivo);
        const urlDescarga = await getDownloadURL(storageRef);

        await addDoc(collection(db, coleccionInformes), {
          anio: anioInforme,
          mes: mesInforme,
          descripcion: nombreOriginal,
          archivoUrl: urlDescarga,
          nombreArchivo: nombreOriginal,
          fechaSubida: new Date().toLocaleDateString('es-PE')
        });

        subidos++;
        setProgresoInforme(Math.round((subidos / totalArchivos) * 100));
      }

      await obtenerRegistros();
      alert(`¡Se subieron ${totalArchivos} documento(s) con éxito!`);
    } catch (error) {
      console.error("Error al subir los archivos:", error);
      alert("Hubo un error al subir los archivos.");
    } finally {
      setTimeout(() => {
        setSubiendoVoucher(false);
        setProgresoInforme(0);
      }, 400);
      e.target.value = null;
    }
  };

  // 📂 Funciones para Documentos Permanentes
  const subirDocumentoPermanente = async (e) => {
    const archivo = e.target.files[0];
    if (!archivo) return;

    try {
      setSubiendoPermanente(true);
      const storageRef = ref(storage, `documentos_permanentes_${edificioIdActivo}/${Date.now()}_${archivo.name}`);
      await uploadBytes(storageRef, archivo);
      const archivoUrl = await getDownloadURL(storageRef);

      const nuevoDocData = {
        nombre: archivo.name,
        descripcion: archivo.name,
        archivoUrl,
        fechaSubida: new Date().toLocaleDateString('es-PE')
      };

      const docRef = await addDoc(collection(db, `documentos_permanentes_${edificioIdActivo}`), nuevoDocData);
      
      setDocumentosPermanentes(prev => [...prev, { id: docRef.id, ...nuevoDocData }]);
      alert("✅ ¡Documento permanente subido con éxito!");
    } catch (error) {
      console.error("Error al subir documento permanente:", error);
      alert("❌ Hubo un error al subir el archivo.");
    } finally {
      setSubiendoPermanente(false);
      e.target.value = '';
    }
  };

  const eliminarDocumentoPermanente = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este documento permanente?")) return;

    try {
      await deleteDoc(doc(db, `documentos_permanentes_${edificioIdActivo}`, id));
      setDocumentosPermanentes(prev => prev.filter(d => d.id !== id));
      alert("🗑️ Documento eliminado con éxito.");
    } catch (error) {
      console.error("Error al eliminar documento permanente:", error);
      alert("❌ No se pudo eliminar el documento.");
    }
  };

  const agregarDiaForm = () => {
    if (!nuevoDiaInput.trim()) return;
    setFormArea(prev => ({
      ...prev,
      diasList: [...prev.diasList, nuevoDiaInput.trim()]
    }));
    setNuevoDiaInput('');
  };

  const eliminarDiaForm = (index) => {
    setFormArea(prev => ({
      ...prev,
      diasList: prev.diasList.filter((_, i) => i !== index)
    }));
  };

  const agregarHoraForm = () => {
    if (!nuevaHoraInput.trim()) return;
    setFormArea(prev => ({
      ...prev,
      horasList: [...prev.horasList, nuevaHoraInput.trim()]
    }));
    setNuevaHoraInput('');
  };

  const eliminarHoraForm = (index) => {
    setFormArea(prev => ({
      ...prev,
      horasList: prev.horasList.filter((_, i) => i !== index)
    }));
  };

  const guardarAreaSocial = async (e) => {
    e.preventDefault();
    if (!formArea.nombre) return;

    const datosArea = { 
      nombre: formArea.nombre, 
      costo: formArea.costo ? `S/ ${parseFloat(formArea.costo).toFixed(2)}` : 'Gratis', 
      garantia: formArea.garantia ? `S/ ${parseFloat(formArea.garantia).toFixed(2)}` : '',
      limpieza: formArea.limpieza || 'Limpieza incluida',
      horariosPorDia: formArea.horariosPorDia || [],
      reglas: formArea.reglas || 'Sin reglas',
      bloqueoDiaCompleto: formArea.bloqueoDiaCompleto || false, // 👈 NUEVO: Se guarda en Firestore
      diasList: ['Lunes a Domingo'],
      horasList: ['09:00 - 22:00']
    };

    if (formArea.id) {
      await updateDoc(doc(db, coleccionAreas, formArea.id), datosArea);
    } else {
      await addDoc(collection(db, coleccionAreas), datosArea);
    }

    setFormArea({ 
      nombre: '', 
      costo: '', 
      garantia: '', 
      horariosPorDia: [], 
      reglas: '', 
      limpieza: 'Limpieza incluida',
      bloqueoDiaCompleto: false // 👈 NUEVO 
    });
    setMostrandoModalArea(false);
    await obtenerRegistros();
    alert("¡Área social guardada con éxito!");
  };

  const cancelarReserva = async (id) => {
    if (window.confirm("¿Liberar horario?")) {
      await deleteDoc(doc(db, coleccionReservas, id));
      await obtenerRegistros();
    }
  };

  const crearReserva = async (e) => {
    e.preventDefault();

    if (usuarioLogueado?.departamento?.bloqueadoReservas) {
      alert("❌ Su cuenta cuenta con restricción temporal para reservar áreas sociales debido a cuotas de mantenimiento pendientes o morosidad. Por favor, comuníquese con la administración.");
      return;
    }

    if (!formReserva.areaId || !formReserva.fecha) return;

    // 🔒 VALIDACIÓN DE BLOQUEO DE DÍA COMPLETO
    const areaSeleccionada = areasSociales.find(a => a.id === formReserva.areaId);
    if (areaSeleccionada?.bloqueoDiaCompleto) {
      const yaReservadoElDia = reservas.some(r => r.areaId === formReserva.areaId && r.fecha === formReserva.fecha);
      if (yaReservadoElDia) {
        alert("❌ Lo sentimos, esta fecha ya se encuentra completamente reservada para esta área.");
        return;
      }
    }

    try {
      await addDoc(collection(db, coleccionReservas), {
        areaId: formReserva.areaId,
        departamento: usuarioLogueado.departamento.departamento,
        fecha: formReserva.fecha,
        horario: areaSeleccionada?.bloqueoDiaCompleto ? 'Día Completo' : formReserva.horario
      });
      setFormReserva({ areaId: '', departamento: '', fecha: '', horario: 'Mañana (09:00 - 14:00)' });
      await obtenerRegistros();
      alert("¡Reserva realizada con éxito!");
    } catch (error) {
      console.error("Error al crear reserva:", error);
      alert("Hubo un error al realizar la reserva.");
    }
  };

  const crearReservaPersonal = async (formReservaPersonal) => {
    if (!formReservaPersonal.areaId || !formReservaPersonal.fecha || !formReservaPersonal.departamento) return;
    
    const areaSeleccionada = areasSociales.find(a => a.id === formReservaPersonal.areaId);
    if (areaSeleccionada?.bloqueoDiaCompleto) {
      const yaReservadoElDia = reservas.some(r => r.areaId === formReservaPersonal.areaId && r.fecha === formReservaPersonal.fecha);
      if (yaReservadoElDia) {
        alert("❌ Esta fecha ya se encuentra reservada para esta área.");
        return;
      }
    }

    try {
      await addDoc(collection(db, coleccionReservas), {
        areaId: formReservaPersonal.areaId,
        departamento: formReservaPersonal.departamento,
        fecha: formReservaPersonal.fecha,
        horario: areaSeleccionada?.bloqueoDiaCompleto ? 'Día Completo' : formReservaPersonal.horario
      });
      await obtenerRegistros();
      alert("¡Reserva registrada con éxito por el personal!");
    } catch (error) {
      console.error("Error al registrar reserva por personal:", error);
      alert("Hubo un error al guardar la reserva.");
    }
  };

  const guardarPropietarioManual = async (e) => {
    e.preventDefault();
    if (!formProp.departamento || !formProp.nombre) return;
    const dptoLimpio = String(formProp.departamento).trim();
    const idDoc = editandoId || `dpto_${dptoLimpio.replace(/\s+/g, '_')}`;
     
    await setDoc(doc(db, nombreColeccion, idDoc), {
      departamento: dptoLimpio,
      nombre: String(formProp.nombre).trim(),
      celular: String(formProp.celular || '-').trim(),
      correo: String(formProp.correo || '-').trim(),
    }, { merge: true });

    setMostrandoModalPropietario(false);
    setEditandoId(null);
    setFormProp({ departamento: '', nombre: '', celular: '', correo: '' });
    await obtenerRegistros();
    alert("¡Propietario guardado con éxito!");
  };

  const aprobarYEnviarRecibos = async () => {
    if (propietarios.length === 0) return;
    if (window.confirm(`¿Aprobar recibos y archivarlos en el Archivo Histórico?`)) {
      try {
        const batch = writeBatch(db);

        propietarios.forEach(prop => {
          const mesReal = prop.mes || mesEnvio;
          const anioReal = prop.anio || anioEnvio;

          const idHistoricoUnico = `hist_${anioReal}_${mesReal}_dpto_${prop.departamento}`;
          const refHistDoc = doc(db, coleccionHistorico, idHistoricoUnico);

          batch.set(refHistDoc, {
            anio: anioReal,
            mes: mesReal, 
            departamento: prop.departamento,
            nombre: prop.nombre,
            cuota: prop.cuota || 'S/ 0.00',
            pdfUrl: prop.pdfUrl || '',
            pdfUrls: prop.pdfUrls || [],
            correo: prop.correo || '',
            celular: prop.celular || '',
            fechaEmision: prop.fechaEmision || '',
            fechaVencimiento: prop.fechaVencimiento || '',
            voucherUrl: '',
            estadoPago: 'Pendiente de validación',
            fechaAprobacion: new Date().toLocaleDateString('es-PE')
          });

          const refDoc = doc(db, nombreColeccion, prop.id);
          batch.update(refDoc, {
            cuota: '',
            mes: '',
            anio: '',
            fechaEmision: '',
            fechaVencimiento: '',
            pdfUrl: '',
            pdfUrls: [],
            estado: 'Pendiente'
          });
        });

        await batch.commit();
        await obtenerRegistros();

        setAnioHistorico(anioEnvio);
        setAnioActivoBusqueda(anioEnvio);

        setPestanaLateral('historico');
        alert(`✅ ¡Recibos aprobados, archivados y removidos de la previsualización correctamente!`);
      } catch (error) {
        console.error("Error al aprobar recibos:", error);
        alert("Hubo un error al procesar la aprobación masiva.");
      }
    }
  };

  const formatearMonto = (v) => `S/ ${parseFloat(String(v).replace(/[^0-9.-]+/g, "") || 0).toFixed(2)}`;
  const informesFiltrados = informesEconomicos.filter(inf => inf.anio === anioInforme && inf.mes === mesInforme);
  
  const historicoFiltrado = datosHistoricos.filter(h => {
    const coincideFiltros = h.anio === anioActivoBusqueda;
    if (!busquedaHistorico.trim()) return coincideFiltros;
     
    const textoBuscado = busquedaHistorico.toLowerCase();
    const coincideTexto = String(h.departamento).toLowerCase().includes(textoBuscado) || 
                         String(h.nombre).toLowerCase().includes(textoBuscado) ||
                         String(h.mes || '').toLowerCase().includes(textoBuscado);
    return coincideFiltros && coincideTexto;
  });

  const dptoBaseProp = usuarioLogueado?.departamento?.departamento;
  const cuotasPropietarioPorAnio = datosHistoricos.filter(h => {
    if (!h.departamento || !dptoBaseProp) return false;
    const dptoItem = String(h.departamento).trim();
    return (dptoItem === dptoBaseProp || dptoItem.startsWith(dptoBaseProp + '_')) && h.anio === anioSeleccionadoProp;
  });

  return (
    <div className="App">
      <header className="panel-header" style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '30px 20px', textAlign: 'center' }}>
        <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img 
            src={isotipoLogo} 
            alt="MMD&L Edificios" 
            style={{ height: '75px', width: 'auto', objectFit: 'contain' }} 
          />
        </div>

        <h1 style={{ margin: '0 0 5px 0' }}>MMD&amp;L EDIFICIOS SAC</h1>
        <p className="tagline" style={{ margin: 0 }}>"Calidad y honestidad en la administración de su edificio."</p>

        {usuarioLogueado && (
          <button 
            onClick={() => { setUsuarioLogueado(null); setEdificioActual(''); }}
            style={{ position: 'absolute', top: '20px', right: '20px', backgroundColor: '#dc2626', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.85rem' }}
          >
            Cerrar Sesión 🚪
          </button>
        )}
      </header>

      <main className="panel-content" style={{ maxWidth: '100%', padding: '0 20px' }}>
         
         {!usuarioLogueado ? (

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', boxSizing: 'border-box', padding: '40px 20px', position: 'relative' }}>
            <div style={{ maxWidth: '420px', width: '90%', backgroundColor: 'white', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', textAlign: 'left', boxSizing: 'border-box' }}>

              <h2 style={{ color: '#0f172a', textAlign: 'center', marginBottom: '5px' }}>Iniciar Sesión</h2>

              <p style={{ color: '#64748b', fontSize: '0.85rem', textAlign: 'center', marginBottom: '25px' }}>
                {pasoAdminLogin === 'credenciales'
                  ? 'Acceso exclusivo para administradores, personal y propietarios autorizados.'
                  : '🔐 Seguridad Adicional: Dibuja tu Patrón de Administrador'}
              </p> 
               
              {pasoAdminLogin === 'credenciales' ? (
                <form onSubmit={manejarLogin} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                  <div>
                    <label style={{ fontSize: '0.85rem', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#334155' }}>Usuario:</label>
                    <input 
                      type="text" 
                      placeholder="Ej. edificio101" 
                      value={inputUsuario}
                      onChange={e => setInputUsuario(e.target.value)}
                      style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '1rem', boxSizing: 'border-box' }}
                      required
                    />
                  </div>

                  <div>
                    <label style={{ fontSize: '0.85rem', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#334155' }}>Contraseña:</label>
                    <input 
                      type="password" 
                      placeholder="********" 
                      value={inputPassword}
                      onChange={e => setInputPassword(e.target.value)}
                      style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '1rem', boxSizing: 'border-box' }}
                      required
                    />
                  </div>

                  <button type="submit" style={{ backgroundColor: '#0284c7', color: 'white', border: 'none', padding: '12px', borderRadius: '6px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', marginTop: '10px' }}>
                    Acceder al Sistema 🚀
                  </button>
                </form>
              ) : (
                <div style={{ textAlign: 'center' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px', maxWidth: '220px', margin: '20px auto' }}>
                    {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map(punto => (
                      <button
                        key={punto}
                        type="button"
                        onClick={() => {
                          const nuevoPatron = patronDibuja ? `${patronDibuja}-${punto}` : punto;
                          setPatronDibuja(nuevoPatron);
                        }}
                        style={{
                          width: '60px',
                          height: '60px',
                          borderRadius: '50%',
                          border: '2px solid #0284c7',
                          backgroundColor: patronDibuja.includes(punto) ? '#0284c7' : '#f8fafc',
                          color: patronDibuja.includes(punto) ? 'white' : '#0284c7',
                          fontSize: '1.2rem',
                          fontWeight: 'bold',
                          cursor: 'pointer',
                          margin: '0 auto'
                        }}
                      >
                        {punto}
                      </button>
                    ))}
                  </div>

                  <p style={{ fontSize: '0.9rem', color: '#334155', fontWeight: 'bold', marginBottom: '15px' }}>
                    Secuencia: {patronDibuja || '(Toca los puntos en orden)'}
                  </p>

                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button 
                      type="button" 
                      onClick={() => {
                        if (patronDibuja === patronSecretoAdmin) {
                          setUsuarioLogueado('admin');
                          setPasoAdminLogin('credenciales');
                          setPatronDibuja('');
                          setInputUsuario('');
                          setInputPassword('');
                        } else {
                          alert("❌ Patrón de administrador incorrecto. Inténtalo de nuevo.");
                          setPatronDibuja('');
                        }
                      }}
                      style={{ flex: 1, backgroundColor: '#16a34a', color: 'white', border: 'none', padding: '10px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}
                    >
                      Confirmar Patrón ✓
                    </button>
                    <button 
                      type="button" 
                      onClick={() => { setPasoAdminLogin('credenciales'); setPatronDibuja(''); }}
                      style={{ backgroundColor: '#94a3b8', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Botón flotante exclusivo para la ventana de login */}
            <BotonInstalarPWA />
          </div>
        ) : usuarioLogueado.tipo === 'global' ? (
          <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', backgroundColor: 'white', padding: '15px 25px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
              <div>
                <h3 style={{ margin: 0, color: '#1e293b' }}>🌐 Portal Global MMD&L</h3>
                <p style={{ margin: '3px 0 0 0', fontSize: '0.8rem', color: '#64748b' }}>Sesión activa: <strong>globalmmdl</strong></p>
              </div>
            </div>
            <PortalGlobal />
          </div>
        ) : usuarioLogueado.tipo === 'propietario' ? (
          <PropietarioPortal 
            usuarioLogueado={usuarioLogueado}
            pestanaPropietario={pestanaPropietario}
            setPestanaPropietario={setPestanaPropietario}
            anioSeleccionadoProp={anioSeleccionadoProp}
            setAnioSeleccionadoProp={setAnioSeleccionadoProp}
            cuotasPropietarioPorAnio={cuotasPropietarioPorAnio}
            formatearMonto={formatearMonto}
            subiendoVoucherPropId={subiendoVoucherPropId}
            subirVoucherPropietario={subirVoucherPropietario}
            areasSociales={areasSociales}
            formReserva={formReserva}
            setFormReserva={setFormReserva}
            crearReserva={crearReserva}
            reservas={reservas}
            anioInforme={anioInforme}
            setAnioInforme={setAnioInforme}
            mesInforme={mesInforme}
            setMesInforme={setMesInforme}
            informesFiltrados={informesFiltrados}
            comunicados={datosNotificaciones}
            documentosPermanentes={documentosPermanentes}
          />
        ) : usuarioLogueado.tipo === 'personal' ? (
          <ReservasEdificio 
            usuarioLogueado={usuarioLogueado}
            areasSociales={areasSociales}
            reservas={reservas}
            crearReservaPersonal={crearReservaPersonal}
            cancelarReserva={cancelarReserva}
          />
        ) : (
          <div>
            {!edificioActual ? (
              <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', flexWrap: 'wrap', gap: '15px' }}>
                  <div>
                    <h2>🏢 Hub Principal - Edificios Administrados</h2>
                    <p style={{ color: '#666', margin: '5px 0 0 0' }}>Selecciona un edificio para ingresar a su panel de control.</p>
                  </div>
                  <button onClick={() => setMostrandoModalNuevo(true)} style={{ backgroundColor: '#16a34a', color: 'white', border: 'none', padding: '12px 22px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>➕ Nuevo Edificio</button>
                </div>

                {mostrandoModalNuevo && (
                  <div style={{ backgroundColor: '#f0fdf4', border: '2px solid #bbf7d0', padding: '20px', borderRadius: '10px', marginBottom: '30px' }}>
                    <h3 style={{ color: '#166534', marginTop: 0 }}>Registrar Nuevo Edificio</h3>
                    <form onSubmit={agregarNuevoEdificio} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                      <input type="text" placeholder="Ej. Edificio Larco..." value={nuevoEdificioNombre} onChange={e => setNuevoEdificioNombre(e.target.value)} style={{ flex: '1', padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db' }} required />
                      <button type="submit" style={{ backgroundColor: '#0284c7', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Guardar</button>
                      <button type="button" onClick={() => setMostrandoModalNuevo(false)} style={{ backgroundColor: '#9ca3af', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Cancelar</button>
                    </form>
                  </div>
                )}

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
                  {listaEdificios.map((edif) => (
                    <div key={edif.id} onClick={() => setEdificioActual(edif)} style={{ backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '25px', cursor: 'pointer', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', position: 'relative' }}>
                      <button title="Eliminar edificio" onClick={(e) => eliminarEdificio(e, edif)} style={{ position: 'absolute', top: '15px', right: '15px', backgroundColor: '#fee2e2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: '6px', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>🗑️</button>
                      <div style={{ fontSize: '2.5rem', marginBottom: '10px' }}>🏢</div>
                      <h3 style={{ margin: '0 0 8px 0', color: '#1f2937' }}>{edif.nombre}</h3>
                      <p style={{ color: '#6b7280', fontSize: '0.85rem', margin: '0 0 15px 0' }}>Panel de control independiente.</p>
                      <span style={{ display: 'inline-block', backgroundColor: '#e0f2fe', color: '#0369a1', padding: '6px 12px', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 'bold' }}>Ingresar →</span>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', minHeight: '75vh', marginTop: '10px', gap: '20px', alignItems: 'flex-start', textAlign: 'left' }}>
                <aside style={{ width: '280px', backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px' }}>
                  <div style={{ marginBottom: '20px', borderBottom: '1px solid #e2e8f0', paddingBottom: '15px' }}>
                    <span style={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase' }}>Edificio Activo:</span>
                    <h3 style={{ margin: '2px 0 0 0', color: '#0f172a', fontSize: '1.2rem' }}>{edificioActual.nombre}</h3>
                    
                    {!editandoNombreEdificio ? (
                      <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                        <button 
                          onClick={() => { setEditandoNombreEdificio(true); setNombreEdificioEditado(edificioActual.nombre); }} 
                          style={{ background: 'none', border: 'none', color: '#0284c7', fontSize: '0.8rem', cursor: 'pointer', padding: 0, textDecoration: 'underline', fontWeight: 'bold' }}
                        >
                          ✏️ Editar Nombre
                        </button>
                        <span style={{ color: '#cbd5e1' }}>|</span>
                        <button onClick={() => setEdificioActual('')} style={{ background: 'none', border: 'none', color: '#64748b', fontSize: '0.8rem', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}>← Cambiar</button>
                      </div>
                    ) : (
                      <form onSubmit={guardarNombreEdificio} style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <input 
                          type="text" 
                          value={nombreEdificioEditado} 
                          onChange={(e) => setNombreEdificioEditado(e.target.value)} 
                          style={{ padding: '6px 8px', borderRadius: '4px', border: '1px solid #cbd5e1', fontSize: '0.9rem' }}
                          required 
                        />
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button type="submit" style={{ backgroundColor: '#16a34a', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 'bold', cursor: 'pointer' }}>Guardar</button>
                          <button type="button" onClick={() => setEditandoNombreEdificio(false)} style={{ backgroundColor: '#94a3b8', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 'bold', cursor: 'pointer' }}>Cancelar</button>
                        </div>
                      </form>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <button onClick={() => setPestanaLateral('propietarios')} style={{ backgroundColor: pestanaLateral === 'propietarios' ? '#0284c7' : 'transparent', color: pestanaLateral === 'propietarios' ? 'white' : '#334155', border: 'none', padding: '12px 15px', borderRadius: '8px', textAlign: 'left', fontWeight: 'bold', cursor: 'pointer' }}>👥 Directorio de Propietarios</button>
                    <button onClick={() => setPestanaLateral('personal')} style={{ backgroundColor: pestanaLateral === 'personal' ? '#0284c7' : 'transparent', color: pestanaLateral === 'personal' ? 'white' : '#334155', border: 'none', padding: '12px 15px', borderRadius: '8px', textAlign: 'left', fontWeight: 'bold', cursor: 'pointer' }}>👷 Gestión de Personal</button>
                    <button onClick={() => setPestanaLateral('areas_sociales')} style={{ backgroundColor: pestanaLateral === 'areas_sociales' ? '#0284c7' : 'transparent', color: pestanaLateral === 'areas_sociales' ? 'white' : '#334155', border: 'none', padding: '12px 15px', borderRadius: '8px', textAlign: 'left', fontWeight: 'bold', cursor: 'pointer' }}>🎉 Áreas Sociales y Reservas</button>
                    <button onClick={() => setPestanaLateral('informe_economico')} style={{ backgroundColor: pestanaLateral === 'informe_economico' ? '#0284c7' : 'transparent', color: pestanaLateral === 'informe_economico' ? 'white' : '#334155', border: 'none', padding: '12px 15px', borderRadius: '8px', textAlign: 'left', fontWeight: 'bold', cursor: 'pointer' }}>📊 Informe Económico y Vouchers</button>
                    <button onClick={() => setPestanaLateral('notificaciones')} style={{ backgroundColor: pestanaLateral === 'notificaciones' ? '#0284c7' : 'transparent', color: pestanaLateral === 'notificaciones' ? 'white' : '#334155', border: 'none', padding: '12px 15px', borderRadius: '8px', textAlign: 'left', fontWeight: 'bold', cursor: 'pointer' }}>📢 Enviar Notificaciones</button>
                    <button onClick={() => setPestanaLateral('carga')} style={{ backgroundColor: pestanaLateral === 'carga' ? '#0284c7' : 'transparent', color: pestanaLateral === 'carga' ? 'white' : '#334155', border: 'none', padding: '12px 15px', borderRadius: '8px', textAlign: 'left', fontWeight: 'bold', cursor: 'pointer' }}>📥 Carga de Información</button>
                    <button onClick={() => setPestanaLateral('revision')} style={{ backgroundColor: pestanaLateral === 'revision' ? '#0284c7' : 'transparent', color: pestanaLateral === 'revision' ? 'white' : '#334155', border: 'none', padding: '12px 15px', borderRadius: '8px', textAlign: 'left', fontWeight: 'bold', cursor: 'pointer' }}>🔍 Previsualización y Aprobación</button>
                    <button onClick={() => setPestanaLateral('historico')} style={{ backgroundColor: pestanaLateral === 'historico' ? '#0284c7' : 'transparent', color: pestanaLateral === 'historico' ? 'white' : '#334155', border: 'none', padding: '12px 15px', borderRadius: '8px', textAlign: 'left', fontWeight: 'bold', cursor: 'pointer' }}>📁 Archivo Histórico</button>
                  </div>
                </aside>

                <div style={{ flex: '1', backgroundColor: 'white', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '25px' }}>
                   
                  {pestanaLateral === 'propietarios' && (
                    <AdminPropietarios 
                      propietarios={propietarios}
                      edificioActual={edificioActual}
                      mostrandoModalPropietario={mostrandoModalPropietario}
                      setMostrandoModalPropietario={setMostrandoModalPropietario}
                      editandoId={editandoId}
                      setEditandoId={setEditandoId}
                      formProp={formProp}
                      setFormProp={setFormProp}
                      guardarPropietarioManual={guardarPropietarioManual}
                      enviarCredencialesPropietario={enviarCredencialesPropietario}
                      db={db}
                      nombreColeccion={nombreColeccion}
                      obtenerRegistros={obtenerRegistros}
                    />
                  )}

                  {pestanaLateral === 'personal' && (
                    <DatosPersonal 
                       edificioActual={edificioActual} 
                       db={db} 
                    />
                  )}
                  
                  {pestanaLateral === 'areas_sociales' && (
                    <AdminAreasSociales 
                      edificioActual={edificioActual}
                      areasSociales={areasSociales}
                      reservas={reservas}
                      mostrandoModalArea={mostrandoModalArea}
                      setMostrandoModalArea={setMostrandoModalArea}
                      formArea={formArea}
                      setFormArea={setFormArea}
                      nuevoDiaInput={nuevoDiaInput}
                      setNuevoDiaInput={setNuevoDiaInput}
                      nuevaHoraInput={nuevaHoraInput}
                      setNuevaHoraInput={setNuevaHoraInput}
                      agregarDiaForm={agregarDiaForm}
                      eliminarDiaForm={eliminarDiaForm}
                      agregarHoraForm={agregarHoraForm}
                      eliminarHoraForm={eliminarHoraForm}
                      guardarAreaSocial={guardarAreaSocial}
                      cancelarReserva={cancelarReserva}
                      db={db}
                      coleccionAreas={coleccionAreas}
                      coleccionReservas={coleccionReservas}
                      obtenerRegistros={obtenerRegistros}
                    />
                  )}

                  {pestanaLateral === 'informe_economico' && (
                    <AdmiEconomico 
                      anioInforme={anioInforme}
                      setAnioInforme={setAnioInforme}
                      mesInforme={mesInforme}
                      setMesInforme={setMesInforme}
                      informesFiltrados={informesFiltrados}
                      subiendoVoucher={subiendoVoucher}
                      subirVoucherInforme={subirVoucherInforme}
                      descripcionGasto={descripcionGasto}
                      setDescripcionGasto={setDescripcionGasto}
                      db={db}
                      coleccionInformes={coleccionInformes}
                      obtenerRegistros={obtenerRegistros}
                      progresoInforme={progresoInforme}
                      documentosPermanentes={documentosPermanentes}
                      subiendoPermanente={subiendoPermanente}
                      subirDocumentoPermanente={subirDocumentoPermanente}
                      eliminarDocumentoPermanente={eliminarDocumentoPermanente}
                    />
                  )}

                  {pestanaLateral === 'notificaciones' && (
                    <AdminNotificaciones 
                      edificioActual={edificioActual}
                      propietarios={propietarios}
                      tituloNotificacion={tituloNotificacion}
                      setTituloNotificacion={setTituloNotificacion}
                      mensajeNotificacion={mensajeNotificacion}
                      setMensajeNotificacion={setMensajeNotificacion}
                      enviandoNotificacion={enviandoNotificacion}
                      setEnviandoNotificacion={setEnviandoNotificacion}
                      datosNotificaciones={datosNotificaciones}
                      db={db}
                      obtenerRegistros={obtenerRegistros}
                    />
                  )}

                  {pestanaLateral === 'carga' && (
                    <AdminCarga 
                      pestanaCargaSub={pestanaCargaSub}
                      setPestanaCargaSub={setPestanaCargaSub}
                      descargarPlantilla={descargarPlantilla}
                      manejarExcel={manejarExcel}
                      procesandoExcel={procesandoExcel}
                      progresoExcel={progresoExcel}
                      subirPdfsEnBloque={subirPdfsEnBloque}
                      procesandoPdf={procesandoPdf}
                      progresoPdf={progresoPdf}
                      edificioIdActivo={edificioIdActivo}
                      nombreColeccion={nombreColeccion}
                      obtenerRegistros={obtenerRegistros}
                      propietarios={propietarios}
                      irAPrevisualizacion={() => setPestanaLateral('revision')}
                    />
                  )}

                  {pestanaLateral === 'revision' && (
                    <AdminRevision 
                      propietarios={propietarios}
                      enviarRecibosMasivosPorCorreo={enviarRecibosMasivosPorCorreo}
                      limpiarPrevisualizacion={limpiarPrevisualizacion}
                      aprobarYEnviarRecibos={aprobarYEnviarRecibos}
                      formatearMonto={formatearMonto}
                      enviarReciboIndividualPorCorreo={enviarIndividual}
                      aprobarYEnviarReciboIndividual={aprobarYEnviarIndividual}
                    />
                  )}

                  {pestanaLateral === 'historico' && (
                    <AdminHistorico 
                      anioHistorico={anioHistorico}
                      setAnioHistorico={setAnioHistorico}
                      anioActivoBusqueda={anioActivoBusqueda}
                      setAnioActivoBusqueda={setAnioActivoBusqueda}
                      busquedaHistorico={busquedaHistorico}
                      setBusquedaHistorico={setBusquedaHistorico}
                      historicoFiltrado={historicoFiltrado}
                      propietarios={propietarios}
                      formatearMonto={formatearMonto}
                      db={db}
                      coleccionHistorico={coleccionHistorico}
                      obtenerRegistros={obtenerRegistros}
                    />
                  )}

                </div>
              </div>
            )}
          </div>
        )}

      </main>

      <footer style={{ textAlign: 'center', padding: '30px 20px', color: '#64748b', fontSize: '0.85rem', borderTop: '1px solid #e2e8f0', marginTop: '40px', backgroundColor: '#f8fafc' }}>
        <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#1e293b' }}>
          © {new Date().getFullYear()} MMD&amp;L Edificios SAC. Todos los derechos reservados.
        </p>
        <p style={{ margin: '0 0 5px 0', color: '#475569' }}>
          Sistema de gestión y administración de propiedades y condominios.
        </p>
        <p style={{ margin: 0, fontStyle: 'italic', color: '#64748b' }}>
          "Calidad y honestidad en la administración de su edificio."
        </p>
      </footer>

    </div>
  );
}

export default App;